import { createContext } from 'react';

const useLoginContext = createContext();
export default useLoginContext;
